module.exports = {
  i18n: {
    defaultLocale: 'en-US',
    locales: [
      'en-US',
      'en-GB',
      'fil-PH',
      'id-ID',
      'ms-MY',
      'th-TH',
      'es-ES',
      'ar-SA',
      'zh-CN',
      'zh-TW',
      'vi-VN',
      'ja-JP',
      'fr-CA',
      'ko-KR',
    ],
  },
};
